import { useEffect, useRef, useState } from 'react';

import { Client, PlayerId, VifData } from '@suntex.fim/api-client';
import { $ArithmeticOperation, ArithmeticOperation } from '@suntex.fim/enums';

import { resolveStage } from '../vifData';

export function useVifData({
  api,
  playerId,
  preview,
  operation,
  stage: passedStage,
}: {
  api: Client;
  playerId: PlayerId;
  preview: boolean;
  operation: ArithmeticOperation;
  /** Stage from the URL (0 if none). */
  stage: number;
}) {
  const [loading, setLoading] = useState(true);
  const [vifData, setVifData] = useState<VifData>();
  const [savedStage, setSavedStage] = useState(0);
  const loadedRef = useRef(false);

  // Load VIF data and (for players) the saved stage, once.
  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    async function load() {
      const response = await api.get_Modules_VifData({});
      setVifData(response.vifData);

      if (!preview) {
        const stageResponse = await api.get_Player_VifStage({
          playerId,
          operation,
        });
        setSavedStage(stageResponse.stage);
      }

      setLoading(false);
    }

    void load();
  }, [api, preview, operation, playerId]);

  const { slug: opSlug } = $ArithmeticOperation.describe(operation);
  const vifModules = vifData?.[opSlug];

  const { stage, maxAllowedStage } = resolveStage({
    passedStage,
    savedStage,
    preview,
    moduleCount: vifModules?.length ?? 1,
  });

  const vifModule = vifModules?.[stage - 1];
  const title = `VIF - ${$ArithmeticOperation.describe(operation).label}`;
  const subtitle = `${stage}. ${vifModule?.name ?? ''}`;
  return {
    loading,
    vifModule,
    title,
    subtitle,
    opSlug,
    stage,
    maxAllowedStage,
  };
}
